import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center gap-1 md:gap-3 text-white text-2xl md:text-4xl font-semibold" }

import { IconsName } from "@/utils/icons";
import Icon from "./Icon.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    icon: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", _hoisted_1, [
    _createVNode(Icon, {
      name: __props.icon,
      size: "m"
    }, null, 8, ["name"]),
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})